import { IApplicationInitDataResponse } from 'components/DashboardMaintenance/DashboardMaintenance.properties';
import { Api } from 'api/baseApi';

export const getApplicationInitData = async (query: { Include: string }): Promise<IApplicationInitDataResponse> => {

    return Api.post<{ Include: string }, IApplicationInitDataResponse>('Application/Init', query);
};
